import { Expose } from "class-transformer";

export class CreateOnCallHasUserDto {
  @Expose()
  onCallId: string;

  @Expose()
  userId: string;
}
